module.exports = __webpack_public_path__ + "static/typescript-jp-2a2039f868ae07eb4b21d15ff6baf9ce.jpg";